import { platformLabel, useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';
import { platformCustomerUrl } from '@sparklayer-io/spark-dash-core/lib/platform-links';
import { useHandlers } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { JsonBlock } from '@sparklayer-io/spark-dash-ui/components/json-block';
import { Card } from '@ui/themed';
import { t } from 'i18next';
import { I18N_PAGE } from '../constants';
import type { Customer } from '../types';

export function CustomerDetailsCard({ customer }: { customer: Customer }) {
  const { navigationHandler } = useHandlers();
  const { platform, store_id } = useEnv();
  const platformUrl = platformCustomerUrl(platform, store_id, customer.external_id);

  return (
    <Card>
      <Card.Header
        headingLevel="h2"
        primaryAction={
          platformUrl
            ? {
                icon: 'externalLink',
                label: t(`${I18N_PAGE}.details.view_in_platform`, {
                  platform: platformLabel(platform),
                }),
                onClick: () =>
                  navigationHandler.navigate(platformUrl, { absolute: true, newTab: true }),
              }
            : undefined
        }
      >
        {t(`${I18N_PAGE}.details.title`)}
      </Card.Header>
      <Card.Body>
        <JsonBlock value={customer} show />
      </Card.Body>
    </Card>
  );
}
